import { render, staticRenderFns } from "./ClientSection.vue?vue&type=template&id=3b65e904&"
import script from "./ClientSection.vue?vue&type=script&lang=js&"
export * from "./ClientSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports